<template>
  <div class="settings-container" v-if="props.data">
    <Alert v-if="!programYes"  svgName="lock" className="yellow">
        <p>
            Your current plan does not have access to this feature.
            <a v-if="Store.state.projectName !== 'cj'" :href="`mailto:${Store.state.mail_to_creator}?subject=${Store.state.user_data.merchant_account.merchant_display_name} - Upgrade to Custom Subdomain&body= Please provide your name and contact info. A representative will contact you in 1-2 business days.`" target="_blank">Contact us</a>
            <a v-else href="#" @click.prevent="openSupportForm">Contact us</a>
            to upgrade your account
        </p>
    </Alert>

    <div class="section-header" v-if="props.data.manageApplications">
      <h3>Manage applications</h3>
      <el-select v-if="props.canEdit" v-model="props.data.manageApplications.permission" default-first-option
        @change="handleApplicationsChange" :disabled="!programYes">
        <el-option v-for="item in props.data.manageApplications.permissionOption" :key="item.type" :label="item.name"
          :value="item.type" />
      </el-select>
      <span v-else>{{ switchParentText(props.data.manageApplications.permission) }}</span>
    </div>

    <div class="setting-item indented" v-if="props.data.createApplications">
      <span>Create applications</span>
      <div v-if="props.data.manageApplications.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.createApplications.permission === 100"
          @click.native="props.data.manageApplications.permission == 50 ? null :switchItem(props.data, 'createApplications.permission')" 
          :disabled="props.data.manageApplications.permission == 50"/>
        <span v-else>{{ switchText(props.data.createApplications.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.editApplicationSettings">
      <div>
        <span>Edit application settings</span>
        <p class="setting-description">(Includes publishing and closing applications and automated criteria)</p>
      </div>
      <div v-if="props.data.manageApplications.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.editApplicationSettings.permission === 100"
          @click.native="props.data.manageApplications.permission == 50 ? null : switchItem(props.data, 'editApplicationSettings.permission')" 
          :disabled="props.data.manageApplications.permission == 50"/>
        <span v-else>{{ switchText(props.data.editApplicationSettings.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.editEmailTemplates">
      <span>Edit email templates</span>
      <div v-if="props.data.manageApplications.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.editEmailTemplates.permission === 100"
          @click.native="props.data.manageApplications.permission == 50 ? null : switchItem(props.data, 'editEmailTemplates.permission')" 
          :disabled="props.data.manageApplications.permission == 50"/>
        <span v-else>{{ switchText(props.data.editEmailTemplates.permission) }}</span>
      </div>
    </div>

    <div class="section-header section-header-2" v-if="props.data.manageCandidates">
      <h3>Manage candidates</h3>
      <el-select v-if="props.canEdit" v-model="props.data.manageCandidates.permission" default-first-option
        @change="handleCandidatesChange" :disabled="!programYes">
        <el-option v-for="item in props.data.manageCandidates.permissionOption" :key="item.type" :label="item.name"
          :value="item.type" />
      </el-select>
      <span v-else>{{ switchParentText(props.data.manageCandidates.permission) }}</span>
    </div>

    <div class="setting-item indented" v-if="props.data.approveOrRejectApplicants">
      <span>Approve or reject applicants</span>
      <div v-if="props.data.manageCandidates.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.approveOrRejectApplicants.permission === 100"
          @click.native="props.data.manageCandidates.permission == 50 ? null : switchItem(props.data, 'approveOrRejectApplicants.permission')"
          :disabled="props.data.manageCandidates.permission == 50" />
        <span v-else>{{ switchText(props.data.approveOrRejectApplicants.permission) }}</span>
      </div>
    </div>

    <div class="setting-item indented" v-if="props.data.viewApplicantDetails">
      <span>View applicant details</span>
      <div v-if="props.data.manageCandidates.permission !== 0">
        <Switch v-if="props.canEdit" :checked="props.data.viewApplicantDetails.permission === 100"
          @click.native="props.data.manageCandidates.permission == 50 ? null : switchItem(props.data, 'viewApplicantDetails.permission')"
          :disabled="props.data.manageCandidates.permission == 50" />
        <span v-else>{{ switchText(props.data.viewApplicantDetails.permission) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted, computed, getCurrentInstance } from 'vue';
const { proxy } = getCurrentInstance();
const EventBus = proxy.EventBus;
const openSupportForm = () => EventBus.emit('open-global-drawer', 'help-support');
import Switch from '@/components/ui/Switch.vue';
import { ElSelect, ElOption } from 'element-plus';
import { useTeamFunction } from './teamFunction';
import Alert from '@/components/settings/SettingAlert.vue';
import Store from '@/store/index.js';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  isOwner: {
    type: Boolean,
    default: false
  },
  canEdit: {
    type: Boolean,
    default: false
  }
});

const { switchItem,switchText,switchParentText } = useTeamFunction();
const programYes=computed(() => {
  return Store.state.user_data?.merchant_account?.is_enable_ambassador_program;
});
//no access->0, can view only->50, can access->100
//+++++++++++++++++++++++++++++
const handleApplicationsChange = (event) => {
  let val = event !== 100 ? 0 : 100;
  props.data.createApplications.permission = val;
  props.data.editApplicationSettings.permission = val;
  props.data.editEmailTemplates.permission = val;
  if(event === 0) {
    handleCandidatesChange(0);
  }
};
const handleCandidatesChange = (event) => {
  let val = event !== 100 ? 0 : 100;
  props.data.approveOrRejectApplicants.permission = val;
  props.data.viewApplicantDetails.permission = val;
};

// +++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++
onMounted(() => {
 
 setTimeout(()=>{
   if (!programYes.value) {
    props.data.manageApplications.permission = 50;
    props.data.manageCandidates.permission = 50;
    handleApplicationsChange(0);
    handleCandidatesChange(0);
   }

 },1000)

});
</script>

<style scoped></style>